// Mirrors backend/lib/workflow/cardFlowRules.js so the board can block
// disallowed moves before a request is sent.

const getFlowRules = (boardSettings) => {
  const rules = boardSettings?.card_flow?.rules
  return Array.isArray(rules) ? rules : []
}

const matchesCardType = (rule, cardType) => {
  const cardTypes = Array.isArray(rule.card_types) ? rule.card_types : []
  if (!cardTypes.length) {
    return true
  }
  if (typeof cardType !== 'string') {
    return false
  }
  return cardTypes
    .some((item) => item.toLowerCase() === cardType.trim().toLowerCase())
}

// returns null when the source lane is unrestricted for this card type
export const getAllowedLaneIds = (boardSettings, fromLaneId, cardType) => {
  const sourceLane = Number.parseInt(fromLaneId)
  const matching = getFlowRules(boardSettings)
    .filter((rule) => rule.enabled !== false &&
      Number.parseInt(rule.from_lane_id) === sourceLane &&
      matchesCardType(rule, cardType))
  if (!matching.length) {
    return null
  }
  return matching.reduce((allowed, rule) => {
    (rule.allowed_lane_ids || []).forEach((laneId) => {
      const id = Number.parseInt(laneId)
      if (!allowed.includes(id)) {
        allowed.push(id)
      }
    })
    return allowed
  }, [])
}

export const isTransitionAllowed =
(boardSettings, fromLaneId, toLaneId, cardType) => {
  if (Number.parseInt(fromLaneId) === Number.parseInt(toLaneId)) {
    return true
  }
  const allowed = getAllowedLaneIds(boardSettings, fromLaneId, cardType)
  if (allowed === null) {
    return true
  }
  return allowed.includes(Number.parseInt(toLaneId))
}

export const transitionBlockedMessage = (cardType, targetName, singleCard = true) => {
  const isSubtask = typeof cardType === 'string' &&
    cardType.trim().toLowerCase() === SUBTASK_CARD_TYPE
  let label
  if (isSubtask) {
    label = singleCard ? 'Subtask' : 'Subtasks'
  } else if (cardType) {
    label = singleCard ? `${cardType} card` : `${cardType} cards`
  } else {
    label = singleCard ? 'Card' : 'Cards'
  }
  const destination = targetName ? `${targetName} lane` : 'this lane'
  return `${label} cannot be moved to ${destination}. ` +
    'The board workflow pattern does not allow this transition.'
}

const SUBTASK_CARD_TYPE = 'subtask'

const targetsSubtasks = (rule) => (rule.card_types || [])
  .some((cardType) => String(cardType).toLowerCase() === SUBTASK_CARD_TYPE)

// returns null when the source state is unrestricted for subtasks
export const getAllowedSubtaskStates = (boardSettings, fromState) => {
  const sourceState = Number.parseInt(fromState)
  const matching = getFlowRules(boardSettings)
    .filter((rule) => rule.enabled !== false &&
      targetsSubtasks(rule) &&
      Number.parseInt(rule.from_state) === sourceState)
  if (!matching.length) {
    return null
  }
  return matching.reduce((allowed, rule) => {
    (rule.allowed_states || []).forEach((state) => {
      const id = Number.parseInt(state)
      if (!allowed.includes(id)) {
        allowed.push(id)
      }
    })
    return allowed
  }, [])
}

export const isSubtaskStateTransitionAllowed =
(boardSettings, fromState, toState) => {
  if (Number.parseInt(fromState) === Number.parseInt(toState)) {
    return true
  }
  const allowed = getAllowedSubtaskStates(boardSettings, fromState)
  if (allowed === null) {
    return true
  }
  return allowed.includes(Number.parseInt(toState))
}

const SUBTASK_STATE_NAMES = { 1: 'To Do', 2: 'Doing', 3: 'Done' }

export const subtaskTransitionBlockedMessage = (target, singleCard = true) => {
  // target may be a name or a state id, depending on the caller
  const targetName = SUBTASK_STATE_NAMES[Number.parseInt(target)] || target
  const label = singleCard ? 'Subtask' : 'Subtasks'
  const destination = targetName ? `${targetName} state` : 'this state'
  return `${label} cannot be moved to ${destination}. ` +
    'The board workflow pattern does not allow this transition.'
}
